import { SimpleCard } from "@/types/card";

import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";

import styles from "./DoulaTypes.module.css";
import { DoulaTypesSection as DoulaTypeProps } from "@/types/pageBuilder";
import { mapImage } from "@/utils/imageHelper";
import { StrapiImage } from "@/types/strapi";

interface DoulaProp extends DoulaTypeProps {
	title: string;
	subTitle: string;
	sectionBgColor?: string;
	doulaTypes: SimpleCard[];
};

export default function DoulaTypesSection({ title, subTitle, doulaTypes, sectionBgColor }: DoulaProp) {
	return (
		<section
			className="doulaTypes py-11 lg:pb-[170px] lg:pt-[80px]"
			style={{ backgroundColor: sectionBgColor }}
		>
			<div className="max-w-7xl mx-auto px-4 sm:px-6 xl:px-0">
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					className="text-center mb-16"
				>
					{title && (
						<h2 className="font-normal text-black font-abc-prophet text-4xl leading-tight lg:text-[58px] lg:leading-[76px] mb-6">{title}</h2>
					)
					}
					{subTitle && (
						<p className="text-xl lg:text-[24px] text-black font-karla">{subTitle}</p>
					)}
				</motion.div>

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
					{doulaTypes && doulaTypes.map((service, index) => (
						<motion.div
							key={service.id}
							initial={{ opacity: 0, y: 30 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.8, delay: index * 0.1 }}
							viewport={{ once: true }}
						>
							<Card
								className="border-0 shadow-btn-shadow h-full bg-newTheme-cotton"
							>
								<CardContent className={`${styles.doulaCardContent} pt-[53px] px-8 pb-[36px] text-center`}>
									{service.image && (() => {
										const img = mapImage(service.image as StrapiImage, false);
										return img ? (
											<img
												src={img.url}
												alt={img.alternativeText || service.title || ""}
												className="w-auto h-9 mx-auto mb-6 object-cover"
											/>
										) : null;
									})()}
									{service.title && (
										<h3 className="text-4xl lg:text-[32px] lg:leading-10 font-abc-prophet text-black mb-6 lg:mb-14">
											{service.title}
										</h3>
									)}
									{service.description && (
										<p className="text-black font-karla md:text-lg lg:text-xl lg:leading-9">
											{service.description}
										</p>
									)}
								</CardContent>
							</Card>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	)
};